module.exports = __webpack_public_path__ + "static/img/body4.be7d2f7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body4.jpeg
// module id = ugZk
// module chunks = 1